module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "abbrs"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxiii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0006#toc"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-bottom": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("ACT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("AIDS Committee of Toronto")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("ACT[-]UP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("AIDS Coalition to Unleash Power")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("AID")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Acquired Immune Deficiency")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("AIDS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("acquired immune deficiency syndrome, "), _c('i', [_vm._v("also called")]), _vm._v(" acquired immunodeficiency syndrome")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("APA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("American Psychiatric Association")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("ARV")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("AIDS-related virus")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("ASO")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("AIDS Service Organization")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_c('i', [_vm._v("Band")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("And the Band Played On")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_c('i', [_vm._v("BAR")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Bay Area Reporter")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("BCGLA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("British Columbia Gay and Lesbian Archives")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CAJ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Canadian Association of Journalists")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CAS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Canadian AIDS Society")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CBC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Canadian Broadcasting Corporation")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CDC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Centers for Disease Control")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CEH")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Center for Environmental Health")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CID")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Center for Infectious Diseases")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CIJ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Centre for Investigative Journalism")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CLGA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Canadian Lesbian and Gay Archives")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CMV")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("cytomegalovirus")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CPS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Center for Prevention Services")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("EIS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Epidemic Intelligence Service")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("EPO")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Epidemiology Program Office")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("GMHC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Gay Men’s Health Crisis")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("GRID")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("gay related immune deficiency")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("HAART")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("highly active antiretroviral therapy")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("HIV")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("human immunodeficiency virus")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxiv"
    }
  }), _vm._v("HLTV-III")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("human T-cell lymphotropic virus type III")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("IV")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("intravenous")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("KCL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("King’s College London")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("KS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Kaposi’s sarcoma")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("KS/OI")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Kaposi’s sarcoma and opportunistic infections")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("LAV")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("lymphadenopathy-associated virus")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("LCDC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Laboratory Centre for Disease Control")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("LGBT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("lesbian, gay, bisexual, and transgender/transsexual")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_c('i', [_vm._v("MMWR")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Morbidity and Mortality Weekly Report")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("NAC-AIDS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("National Advisory Committee on AIDS")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("NCAB")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("National Cancer Advisory Board")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("NCI")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("National Cancer Institute")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("NIH")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("National Institutes of Health")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_c('i', [_vm._v("NYN")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("New York Native")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("NYU")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("New York University")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("OI")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("opportunistic infection")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("OPV")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oral polio vaccine")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("ORTEP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Oak Ridge Thermal Ellipsoid Plot")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("PCC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Portland Community College")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("PCP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Pneumocystis carinii")]), _vm._v(" pneumonia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("PLWH")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("person living with HIV/AIDS")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("PHS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("[United States] Public Health Service")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("PWA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("person with AIDS "), _c('i', [_vm._v("or")]), _vm._v(" the group People with AIDS")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("SARS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("severe acute respiratory syndrome")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("SES")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("socioeconomic status")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("SFAF")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("San Francisco AIDS Foundation")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("SFPL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("San Francisco Public Library")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("SIV")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("simian immunodeficiency virus")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("STDs")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("sexually transmitted diseases")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("STIs")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("sexually transmitted infections")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("TB")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("tuberculosis")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("UCSF")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("University of California–San Francisco")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("UN")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("United Nations")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("VD")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("venereal disease")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("VDCD")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Venereal Disease Control Division")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77914126","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-mckay-0008.vue
// module id = 75
// module chunks = 0